var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00726 10L2.76446 12.2458L0.5 10L2.76362 7.73417L5.00726 10ZM10.4902 4.51167L14.3531 8.37833L16.6176 6.11333L10.4902 0L4.36289 6.13333L6.62735 8.39833L10.4902 4.51167ZM18.2169 7.73417L15.9732 10L18.2368 12.2658L20.4996 10L18.2169 7.73417ZM10.4902 15.4883L6.62735 11.6017L4.36289 13.8675L10.4902 20L16.6176 13.8667L14.3531 11.6017L10.4902 15.4883ZM10.4902 12.2467L12.7539 9.98L10.4902 7.735L8.22662 10L10.4902 12.2458V12.2467Z",
    fill: "#FFD751"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBinance);
export default __webpack_public_path__ + "static/media/coin-binance.cda96c0acf9b159305805bd3d8b0f1bc.svg";
export { ForwardRef as ReactComponent };